import { __read, __awaiter, __generator } from 'tslib';
import * as React from 'react';
import { useContentfulClient } from '../client.esm.js';
import '../../localization/context.esm.js';
import { countryCodeToLocale } from '../../localization/setup.esm.js';
import '../../localization/utils.esm.js';
import { useLocationLiteCountry } from '@invitae/location-lite-react';
import { ContentTypes } from './ContentfulComponentBlock.types.esm.js';
import { MockContext } from './ContentfulMockPageContext.esm.js';

var Context = React.createContext({});
var getPageCopyRequest = function (pageKey, client, countryCode) {
    return client.getEntries({
        // eslint-disable-next-line  @typescript-eslint/naming-convention
        content_type: ContentTypes.PageCopy,
        // Filter items by page key
        'fields.pageKey': pageKey,
        // Deep level is 2:
        // Page copy -> Component Copy -> Text Copy
        include: 10,
        // Limit is 1 because we should have only one entry for each Page Copy
        limit: 1,
        // locale to get right texts from current locale
        locale: countryCodeToLocale[countryCode],
    });
};
function useClientOrNull() {
    var contentfulClient = useContentfulClient();
    var mocks = React.useContext(MockContext);
    return mocks ? null : contentfulClient;
}
var ContentfulPageContext = function (_a) {
    var pageKey = _a.pageKey, children = _a.children;
    var _b = __read(React.useState(), 2), pageCopy = _b[0], setPageCopy = _b[1];
    var mocks = React.useContext(MockContext);
    var cookieCountry = useLocationLiteCountry();
    // if we have page mocks, we won't be using client
    var client = useClientOrNull();
    var loadPageCopy = React.useCallback(function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var pageCopy, pageCopyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!mocks) return [3 /*break*/, 1];
                    pageCopy = mocks[key];
                    if (!pageCopy) {
                        throw Error("Please provide mock for page with key ".concat(key));
                    }
                    return [3 /*break*/, 4];
                case 1:
                    if (!client) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPageCopyRequest(key, client, cookieCountry)];
                case 2:
                    pageCopyResponse = _a.sent();
                    if (!pageCopyResponse.items || !pageCopyResponse.items.length) {
                        throw Error("Page copy with key ".concat(key, " was not found"));
                    }
                    pageCopy = pageCopyResponse.items[0].fields;
                    return [3 /*break*/, 4];
                case 3: throw Error("Could not create a Contentful client");
                case 4:
                    setPageCopy(pageCopy);
                    return [2 /*return*/];
            }
        });
    }); }, [mocks, client, cookieCountry]);
    React.useEffect(function () {
        loadPageCopy(pageKey);
    }, [pageKey, loadPageCopy]);
    return React.createElement(Context.Provider, { value: { pageCopy: pageCopy } }, children);
};
var usePageCopy = function () {
    var contextValue = React.useContext(Context);
    return contextValue ? contextValue.pageCopy : undefined;
};

export { ContentfulPageContext, usePageCopy };
//# sourceMappingURL=ContentfulPageContext.esm.js.map
